import Jed from 'jed';
import localeData from '@/locale/data';

const I18n = {
  install(Vue) {
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$_i18n = new Jed({});

    // eslint-disable-next-line no-param-reassign
    Vue.$t = function $t(...args) {
      return Vue.prototype.$_i18n.gettext(...args);
    };

    // eslint-disable-next-line no-param-reassign
    Vue.$ngettext = function $ngettext(...args) {
      return Vue.prototype.$_i18n.ngettext(...args);
    };

    // eslint-disable-next-line no-param-reassign
    Vue.$pgettext = function $ngettext(...args) {
      return Vue.prototype.$_i18n.pgettext(...args);
    };

    // eslint-disable-next-line no-param-reassign
    Vue.$sprintf = function $sprintf(...args) {
      return Jed.sprintf(...args);
    };

    Vue.mixin({
      methods: {
        $_setLocale(locale) {
          // eslint-disable-next-line no-param-reassign
          Vue.prototype.$_i18n = new Jed(localeData[locale] || {});
        },

        $t(...args) {
          return Vue.$t(...args);
        },

        $ngettext(...args) {
          return Vue.$ngettext(...args);
        },

        $pgettext(...args) {
          return Vue.$pgettext(...args);
        },

        $sprintf(...args) {
          return Vue.$sprintf(...args);
        },
      },
    });
  },
};

export default I18n;
